import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Icon,
  IconButton
} from '@material-ui/core';
import { BackdropCircular } from 'components';
import MapItemDetails from '../ChangeMapping/MapItemDetails';
import useStyles from '../ChangeMapping/styles';


const DataMappingEditModal = ({
  chargeName,
  productData,
  open,
  setOpen,
  onConfirm
}) => {
  const classes = useStyles();
  const [selectedItem, setSelectedItem] = useState(null);

  const { isChargeCodesMappedLoading } = useSelector((state: IReduxState) => state.rpa);

  useEffect(() => {
    const {
      id,
      sku,
      cost,
      manufacturer,
      brand: catalogBrand,
      replenishment,
      category1: revenueCategory1,
      category2: revenueCategory2,
      category3: revenueCategory3,
      category4: revenueCategory4,
      loyalty_program: loyaltyProgram,
      catalog_name: catalogName
    } = productData;

    setSelectedItem({
      id,
      catalogName,
      sku,
      revenueCategory1,
      revenueCategory2,
      revenueCategory3,
      revenueCategory4,
      replenishment,
      cost,
      catalogBrand,
      manufacturer,
      loyaltyProgram
    });
  }, []);

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="confirm-dialog"
      PaperProps={{
        className: classes.dialogRoot
      }}
      fullWidth
      maxWidth={'lg'}
    >
      <DialogTitle id="confirm-dialog" className={classes.dialogTitleContainer}>
        <div className="flex justify-between items-center py-2">
          <div className="pr-10 pl-4">
            <span>{'Edit for: '}</span>
            <span className="font-normal">{chargeName}</span>
          </div>
          <IconButton
            className="border-radius-4 p-2 bg-white border-1-muted"
            onClick={() => setOpen(false)}
          >
            <Icon fontSize="small">close</Icon>
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent className="px-8 pb-5 relative">
        {!!selectedItem &&
          <MapItemDetails item={selectedItem} setSelectedItem={setSelectedItem} />
        }
        <BackdropCircular loading={isChargeCodesMappedLoading} />
      </DialogContent>
      <DialogActions className={`justify-between py-6 ${classes.dialogActionContainer}`}>
        <Button
          variant="outlined"
          onClick={() => setOpen(false)}
          size="small"
          className="uppercase ml-5"
        >
          Cancel
        </Button>
        <Button
          color="primary"
          variant="contained"
          onClick={() => onConfirm({chargeName, chargeProductData: selectedItem})}
          size="small"
          className="uppercase mr-5"
        >
          Edit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DataMappingEditModal;
